export default __webpack_public_path__ + "static/sidebar-newsletter-0d15d40f25380cd4274d6378f388ae13.svg";